import { Einblenden, Etikett, MitFett } from './Bausteine'
import { einleitung, lagebild } from '@/data/inhalte'
import { ESSEN, KANTEN, KARTE, LAENDER, MAX_ABSTAND, ORTE } from '@/data/karte'

// Signalwelle: braucht WELLE Sekunden bis zum entferntesten Ort, wiederholt sich alle TAKT Sekunden.
// Jeder Ort leuchtet genau dann auf, wenn die Welle ihn erreicht (Verzoegerung = Abstand).
const WELLE = 3.2
const TAKT = 5

const abstand = (x: number, y: number) => Math.hypot(x - ESSEN.x, y - ESSEN.y)

function Karte() {
  return (
    <svg
      viewBox={`0 0 ${KARTE.breite} ${KARTE.hoehe}`}
      className="h-auto w-full overflow-visible"
      role="img"
      aria-label={lagebild.kartenText}
      style={{ ['--takt' as string]: `${TAKT}s` }}
    >
      <g>
        {LAENDER.map(l => {
          const nrw = l.name === 'Nordrhein-Westfalen'
          return (
            <path
              key={l.name}
              d={l.d}
              fill={nrw ? 'rgba(34,195,172,.16)' : 'rgba(200,245,238,.035)'}
              stroke={nrw ? 'rgba(34,195,172,.75)' : 'rgba(200,245,238,.2)'}
              strokeWidth={nrw ? 1.3 : 0.8}
              strokeLinejoin="round"
            />
          )
        })}
      </g>
      {/* Netz zwischen benachbarten Standorten */}
      <g stroke="rgba(34,195,172,.28)" strokeWidth="0.7">
        {KANTEN.map(([a, b]) => (
          <line key={`${a}-${b}`} x1={ORTE[a][0]} y1={ORTE[a][1]} x2={ORTE[b][0]} y2={ORTE[b][1]} />
        ))}
      </g>
      {/* Signalringe aus Essen */}
      {[0, 0.55].map(v => (
        <circle
          key={v}
          className="signal-ring"
          cx={ESSEN.x}
          cy={ESSEN.y}
          r={MAX_ABSTAND}
          fill="none"
          stroke="#22C3AC"
          strokeWidth={v ? 0.8 : 1.6}
          style={{ transformOrigin: `${ESSEN.x}px ${ESSEN.y}px`, animationDelay: `${v}s`, opacity: 0 }}
        />
      ))}
      {/* Standorte */}
      <g>
        {ORTE.map(([x, y, n, kern], i) => (
          <circle
            key={i}
            className="ort-blitz"
            cx={x}
            cy={y}
            r={1.7 + Math.sqrt(n) * 1.15}
            fill={kern ? '#22C3AC' : '#BFEFE7'}
            fillOpacity={kern ? 1 : 0.6}
            style={{ animationDelay: `${((abstand(x, y) / MAX_ABSTAND) * WELLE).toFixed(2)}s` }}
          />
        ))}
      </g>
      {/* Sendeort */}
      <g>
        <circle cx={ESSEN.x} cy={ESSEN.y} r="11" fill="rgba(229,50,45,.18)" className="sende-puls" style={{ transformOrigin: `${ESSEN.x}px ${ESSEN.y}px` }} />
        <circle cx={ESSEN.x} cy={ESSEN.y} r="5" fill="#fff" stroke="#E5322D" strokeWidth="2.5" />
      </g>
    </svg>
  )
}

/** „Worum es geht“ neben einem Lagebild: Firmenstandorte der Branche, Essen sendet. */
export default function Lagebild() {
  return (
    <section id="themen" className="verlauf-nacht relative isolate overflow-hidden py-20 text-white sm:py-28">
      <div className="huelle grid items-center gap-12 lg:grid-cols-[1fr_1.05fr] lg:gap-16">
        <div>
          <Etikett aufDunkel>{einleitung.etikett}</Etikett>
          <Einblenden>
            <h2 className="mt-10 text-[clamp(32px,4.2vw,54px)]">{einleitung.titel}</h2>
          </Einblenden>
          <Einblenden verzoegerung={100}>
            <div className="mt-8 space-y-5 text-[18px] leading-relaxed text-white/80 sm:text-[19px]">
              {einleitung.absaetze.map(absatz => <p key={absatz.slice(0, 20)}><MitFett text={absatz} hell /></p>)}
            </div>
          </Einblenden>
        </div>

        <Einblenden verzoegerung={150}>
          <figure className="relative mx-auto max-w-[520px]">
            <Karte />
            <figcaption className="mt-6 border-t border-white/15 pt-5 text-[13.5px] text-white/65">
              {lagebild.kartenText}
            </figcaption>
          </figure>
        </Einblenden>
      </div>
    </section>
  )
}
